import { baseProdEnv } from './base.prod';
import { Environments } from './types';

export const environment: Environments = baseProdEnv;
environment.ENV_NAME = 'production-backup';
// environment.apiLink = 'https://helios-api-backup-prod.onrender.com';
environment.auto_dispatch_url = 'https://auto-dispatch-backup-prod.onrender.com';
environment.commonApiLink = 'https://connect-common-api-backup-prod.onrender.com/api';
environment.customersApiUrl = 'https://postgrest-zugo.onrender.com';
